const styles = theme => ({
  dialogPaper: {
    overflow: 'visible',
    position: 'relative',
    padding: '20px 30px',
    width: '500px',
  },
  dialogRoot: {
    zIndex: '1250 !important',
  },
  wrapperModal: {
    display: 'flex',
    flexDirection: 'column',
  },
  wrapperContent: {
    gap: '16px',
    display: 'flex',
    flexDirection: 'column',
  },
  cardMain: {
    boxShadow: 'none',
    margin: 0,
  },
  cardBody: {
    padding: 0,
    paddingTop: '16px',
  },
  wrapperHeader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '16px',
  },
  wrapperLabelHeader: {
    height: '40px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  },
  labelHeader: {
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '24px',
  },
  wrapperHeaderInfo: {
    borderTop: `1px solid ${theme.palette.gray[10]}`,
    borderBottom: `1px solid ${theme.palette.gray[10]}`,
    width: '100%',
    padding: '12px 8px',
    gap: '16px 40px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
  },
  wrapperInfo: {
    display: 'flex',
    flexDirection: 'column',
  },
  labelInfo: {
    fontWeight: 500,
    fontSize: '12px',
    color: theme.palette.gray[60],
  },
  valueInfo: {
    fontWeight: 400,
    fontSize: '12px',
    color: theme.palette.gray[40],
  },
  tabsFlexContainer: {
    display: 'flex',
    gap: '12px',
  },
  tab: {
    height: '43px',
    backgroundColor: theme.palette.gray[10],
    color: theme.palette.gray[50],
    // minWidth: '138px',
    borderRadius: '8px 8px 0 0',
    flex: 1,
    minWidth: 0,
    maxWidth: 'none',
  },
  tabSelected: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.gray[80],
    outline: 'none',
  },
  tabDisabled: {
    backgroundColor: theme.palette.gray[5],
    color: theme.palette.gray[20],
    opacity: 0.45,
    cursor: 'not-allowed',
  },
  tabIndicator: {
    backgroundColor: theme.palette.common.yellowGold,
    height: 3,
  },
  wrapperActions: {
    // height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '24px',
    borderTop: `1px solid ${theme.palette.gray[10]}`,
    paddingTop: '14px',
  },
  buttonActions: {
    textTransform: 'capitalize',
    height: '40px',
  },
  highlightValue: {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '16px',
    color: theme.palette.gray[50],
  },
  wrapperCardHeader: {
    top: '-32px',
    margin: '0px !important',
    height: '0px',
  },
  cardIconWarning: {
    padding: '13px !important',
  },
  cardIconClose: {
    background: 'darkgray !important',
    padding: '13px !important',
    float: 'right !important',
    borderRadius: '50% !important',
    marginRight: '0px !important',
    cursor: 'pointer',
    boxShadow: 'gray 10px 10px 50px !important',
  },
  headerIcons: {
    margin: '0px !important',
  },
  wrapperChildren: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '16px',
    gap: '16px',
  },
  boxFields: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '16px 40px',
  },
  boxLabel: {
    alignItems: 'start',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
    height: '58px',
  },
  labelText: {
    padding: '0 8px',
    fontSize: '12px',
    fontWeight: 500,
    color: theme.palette.gray[50],
  },
  wrapperDateTimePicker: {
    display: 'flex',
    flexDirection: 'column',
  },
  wrapperTextFieldLabel: {
    display: 'flex',
    flexDirection: 'column',
  },
  wrapperCheckbox: {
    padding: '16px 10px 0px 10px',
    borderTop: `1px solid ${theme.palette.gray[10]}`,
  },
  checkboxRoot: {
    margin: 0,
    marginRight: '6px',
    width: '20px',
    height: '20px',
  },
  labelCheckbox: {
    fontSize: '12px',
    color: theme.palette.gray[60],
    fontWeight: 500,
  },
  formControlRoot: {
    marginBottom: 0,
  },
  wrapperConfirmAlert: {
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
  },
  confirmAlert: {
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
  },
  confirmAlertHeader: {
    display: 'flex',
    gap: 10,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 16,
  },
  confirmAlertIcon: {
    fontSize: '46px',
    color: theme.palette.common.yellowGold,
  },
  confirmAlertTitle: {
    fontWeight: 500,
    fontSize: '30px',
    color: theme.palette.common.black,
    textTransform: 'uppercase',
  },
  confirmAlertMessages: {
    textAlign: 'start',
    gap: 20,
    display: 'flex',
    flexDirection: 'column',
  },
  confirmAlertText: {
    fontSize: '24px',
    color: theme.palette.common.black,
  },
  formActions: {
    display: 'flex',
    gap: 24,
    justifyContent: 'center',
  },
  wrapperChat: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '16px',
    gap: '16px',
  },
});

export default styles;
